<template>
    <div class="about">
      <TransitionGroup>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Tax Type Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <p class="card-text text-danger italic">Any changes done here will reflect only invoices generated after the change was applied.</p>
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item=>!formHidden.includes(item))" :key="index">
                <float-inp type="date" v-if="dateFields.includes(r)" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
                <float-inp type="text" v-else :label="headers[r] + (headers[r]=='Short Code' ? ' [This will appear in invoices]' : '' )" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <a href="#" v-if="rowData['id']===null || rowData['id']<1" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Create', promptText: 'Solve the sum to create this tax record.', confirmLabel: 'Create', action: () => postBank('post') })" >Create Entity</a>
            <template v-else>
              <a href="#" class="btn btn-warning me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Duplicate', promptText: 'Solve the sum to duplicate this tax record.', confirmLabel: 'Duplicate', action: () => duplicateCurrentRecord() })" >Duplicate</a>
              <a href="#" class="btn btn-success me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Update', promptText: 'Solve the sum to update this tax record.', confirmLabel: 'Update', action: () => postBank('put') })" >Update Entity</a>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this tax record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>
        <cdTable :links="links" title="Taxes" table-name="tax" :hidden="hidden" :headers="headers" :gen-form="false" v-else @popForm="e=>setRowData(e)" ></cdTable>        
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
        
      </TransitionGroup>

      
    </div>
  </template>
  <script>
  import floatInp from '@/parts/floatInp.vue';
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { taxLinks } from '@/cd-links';
  export default{
    components:{
      cdTable, floatInp, ActionCaptchaModal
    },
    data(){
      return {
        links: taxLinks,
        headers:{
            id: "ID",
            name: "Tax name",
            taxcode: "Tax Code",
            description: "Description",
            shortcode: "Short Code",
            perc: "Percentage(%)",
            start_date: "Applicable From",
            end_date: "Applicable To",
            createdAt: "Created On",
            updatedAt: "Updated On",
          },
          dateFields:['start_date','end_date'],
          hidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt' */
          ],
          disabled:['id'],
          formHidden:[
            'creatorId',
            'createdAt',
            'updatedAt',
            'ent_id'
          ],          
          showModal:false,
          rowData:{
            id: null,
            name: null,
            taxcode: null,
            description: null,
            shortcode: null,
            perc: null,
            start_date: null,
            end_date: null
          },
          loading: false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null,
      }
    },
    methods:{
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting tax',
            type: 'danger'
          });
        }
      },
      async postBank(mode){        
        try {
          this.loading=true;
          this.rowData.status=true;
          this.rowData['ent_id']=this.$store.getters.getEntity;
          await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData})
              .then(resp=>{

                if(resp.data.isLoggedIn){
                  this.$store.commit('addAlert', {
                        title: resp.data.title,
                        message: resp.data.msg,
                        type: resp.data.success? 'info' : 'danger'
                    });
                  resp.data.success? this.showModal=false : this.showModal=true;                            
                  }
                else this.$store.dispatch('loggedOut');
              })
              .catch(err=>{
                console.error('Error posting tax:', err);
                this.$store.commit('addAlert', {
                  title: "Error",
                  message: err.response?.data?.msg || err.message || "Error saving tax",
                  type: 'danger'
                });
              })
              .finally(() => {
                this.loading=false;
              })
        } catch(err) {
          console.error('Error in postBank:', err);
          this.$store.commit('addAlert', {
            title: "Error",
            message: err.message || "Error processing form",
            type: 'danger'
          });
          this.loading=false;
        }
      },
      setRowData(e){
        this.rowData=e.rowData;
        if(this.rowData['id']>0) {          
          this.rowData.start_date=new Date(this.rowData['start_date']).toLocaleDateString().split('/').reverse().map(s=>s.padStart(2,"0")).join('-');
          this.rowData.end_date=new Date(this.rowData['end_date']).toLocaleDateString().split('/').reverse().map(s=>s.padStart(2,"0")).join('-');
        }
        else{
          this.rowData.start_date=new Date().toLocaleDateString().split('/').reverse().map(s=>s.padStart(2,"0")).join('-');
          this.rowData.end_date=new Date().toLocaleDateString().split('/').reverse().map(s=>s.padStart(2,"0")).join('-');
        }
        this.showModal=true;
      },
    mounted(){
      if(this.$store.getters.getEntity<1){
                this.$store.commit('addAlert', {
                                                    title: "No Entity Selected!",
                                                    message: "Please select an entity to proceed",
                                                    type: 'warning'
                                                })                
                this.$router.push('/');
            }
      else{
        this.preFetch=true;
      }
    }
  }
}
  </script>
  